module.exports = __webpack_public_path__ + "img/JL.a3d7fbf4.png";